export type DealerFilterOperator = 'EQ' | 'NEQ' | 'IN' | 'GTE' | 'LTE' | 'RANGE'

export type DealerFilterInput = {
    attribute: string
    operator: DealerFilterOperator
    values: string[]
}

export type DealerGeoInput = {
    aroundLatLng?: string
    aroundRadius?: number
    aroundLatLngViaIP?: boolean
    insideBoundingBox?: string
}

export type DealerSearchInput = {
    query?: string
    page?: number
    perPage?: number
    filters?: DealerFilterInput[]
    facets?: string[]
    geo?: DealerGeoInput
}

export type DealerSearchHit = {
    objectID: string
    name: string
    address: string
    city: string
    postal_code: string
    country: string
    country_code: string
    website: string
    brands: string[]
    types: string[]
    websitebepure?: string | null
    websitewoood?: string | null
    _geoloc: { lat: number; lng: number }
    distinct?: string | null
}

export type FacetDistribution = {
    attribute: string
    values: Array<{ value: string; count: number }>
}

export type DealerSearchResult = {
    hits: DealerSearchHit[]
    totalHits: number
    page: number
    perPage: number
    totalPages: number
    processingTimeMs: number
    facets: FacetDistribution[]
}

export const DEALER_SEARCH_QUERY = `
query DealerSearch($input: DealerSearchInput!) {
  dealerSearch(input: $input) {
    hits {
      objectID name address city postal_code country country_code website
      brands types websitebepure websitewoood
      _geoloc { lat lng }
      distinct
    }
    totalHits page perPage totalPages processingTimeMs
    facets { attribute values { value count } }
  }
}`
